import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from './../_helpers';


// create slice

const name = 'category';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
    createExtraReducers(builder);
}
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const categoryActions = { ...slice.actions, ...extraActions };
export const categoryReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        category:{},
        categoryList: [],
        error: null,
        isLoading:false,
        categoryResponse: [],
        deleteCategoryResponse:[]
    }
}

function createExtraActions() {
     const baseUrl = `${process.env.REACT_APP_API_URL}/Category`;
    return {
        getCategoryAll: getCategoryAll(),
        getCategoryById:getCategoryById(),
        saveCategory: saveCategory(),
        deleteCategory:deleteCategory(),
    };

    function getCategoryAll() {
        return createAsyncThunk(
            `${name}/getCategoryAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetCategoryDetails`)
        );
    }
     function getCategoryById() {
        return createAsyncThunk(
            `${name}/getCategoryById`,
             async (detail) => await fetchWrapper.get(`${baseUrl}/GetCategoryDetails?CategoryID=`+detail.CategoryID)
        );
    }

    function saveCategory() {
        return createAsyncThunk(
            `${name}/saveCategory`,
             async (addFormData) => await fetchWrapper.post(`${baseUrl}/InsertUpdateCategory`, addFormData )
        );
    }

    function deleteCategory()
    {
        return createAsyncThunk(
            `${name}/deleteCategory`,
             async (detail) => await fetchWrapper.post(`${baseUrl}/DeleteCategory?CategoryID=${detail.CategoryID}&DeletedBy=${detail.DeletedBy}`)
          
        );
    }
}


function createExtraReducers(builder) {
    builder
        .addCase(extraActions.getCategoryAll.pending, (state) => {
            state.isLoading = false;
            state.error = "";
        })
        .addCase(extraActions.getCategoryAll.fulfilled, (state, action) => {
            state.isLoading = true;
            state.categoryList = action.payload || [];
            state.categoryResponse = [];
            state.deleteCategoryResponse = [];
        })
        .addCase(extraActions.getCategoryAll.rejected, (state, action) => {
            state.isLoading = true;
            state.error = { error: action.error };
        })
        .addCase(extraActions.getCategoryById.pending, (state) => {
            state.category = { loading: true };
        })
        .addCase(extraActions.getCategoryById.fulfilled, (state, action) => {
            state.category = action.payload ? action.payload[0] : null;
            state.categoryResponse = [];
            state.deleteCategoryResponse = [];
        })
        .addCase(extraActions.getCategoryById.rejected, (state, action) => {
            state.category = { error: action.error };
        })
        .addCase(extraActions.saveCategory.pending, (state) => {
            state.categoryResponse = { loading: true };
        })
        .addCase(extraActions.saveCategory.fulfilled, (state, action) => {
            state.categoryResponse = action.payload;
            state.deleteCategoryResponse = [];
        })
        .addCase(extraActions.saveCategory.rejected, (state, action) => {
            state.categoryResponse = { error: action.error };
        })
        .addCase(extraActions.deleteCategory.pending, (state) => {
            state.categoryResponse = { loading: true };
        })
        .addCase(extraActions.deleteCategory.fulfilled, (state, action) => {
            state.deleteCategoryResponse = action.payload;
            state.categoryResponse = [];
        })
        .addCase(extraActions.deleteCategory.rejected, (state, action) => {
            state.deleteCategoryResponse = { error: action.error };
        });
}
